require('./ruleBuilderHeader.i18n.json');
require('./ruleBuilderHeader.tpl.html');
require('./ruleBuilderHeaderController.js');
require('./ruleActionRepository.js');
require('./ruleActionsUtil.js');

const RuleBuilderHeaderComponent = {
    templateUrl: '/configuration/ruleBuilder/header/ruleBuilderHeader.tpl.html',
    controller: 'ruleBuilderHeaderController',
    bindings: {}
};

angular.module('ums')
    .component('uiRuleBuilderHeader', RuleBuilderHeaderComponent);
